import styled from "@emotion/styled";

import { fontMerriweather, fontRoboto, setFullViewportWidthStyles, theme } from "shared/lib/styles";

import { ArticleShareWidget } from "scmp-app/components/article/article-share-widget";
import { EntityLink } from "scmp-app/components/entity-link";

export const Container = styled.div`
  ${setFullViewportWidthStyles()}
  position: relative;

  overflow: hidden;
`;

export const StyledFigure = styled.figure`
  inline-size: 100%;
  margin-block-end: 32px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 40px;
  }
`;

export const StyledImage = styled.img`
  inline-size: 100%;
`;

export const StyledFigcaption = styled.figcaption`
  max-inline-size: 335px;
  margin-block-start: 12px;
  margin-inline: auto;

  text-align: center;

  ${theme.breakpoints.up("tablet")} {
    max-inline-size: 672px;
  }

  ${theme.breakpoints.up("desktop")} {
    max-inline-size: 856px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  margin-block: 32px;
  padding-inline: 40px;

  ${theme.breakpoints.up("tablet")} {
    max-inline-size: 856px;
    margin-block: 40px;
    margin-inline: auto;
    padding-inline: 28px;
  }
`;

export const Section = styled.div`
  margin-block-end: 16px;
`;

export const Headline = styled.div`
  font-weight: 300;
  font-size: 32px;
  font-family: ${fontMerriweather};
  line-height: 38px;
  text-align: center;

  ${theme.breakpoints.up("tablet")} {
    font-size: 40px;
    line-height: 52px;
  }
`;

export const StyledEntityLink = styled(EntityLink)`
  margin-block-start: 20px;
  padding-block: 4px;
  padding-inline: 8px;

  color: #000000;
  font-size: 18px;
  font-family: ${fontRoboto};
  line-height: 21px;

  background-color: #ffffff;
  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 40px;
  }
`;

export const StyledArticleShareWidget = styled(ArticleShareWidget)`
  display: flex;

  margin-block-start: 32px;
  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 24px;
  }

  svg > rect {
    display: none;
  }
`;
